import { Smile } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SmileyIcon = createLucideIcon(Smile);
